import React from 'react';

export const CenterBox = ({ children }) => (
    <div
        className="center-xs middle-xs"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
        {children}
    </div>
);



// WEBPACK FOOTER //
// ./app/components/Vessels/List/utils.jsx